/**
 * 通知状态
 */
export enum NOTICE_TYPE_ENUM {
  /**
   * 待发布
   */
   READY = '0',
   /**
    * 已撤销
    */
   WITHDRAW = '1',
   /**
    * 更新中
    */
   UPDATING = '2',
   /**
    * 已完成
    */
   COMPLETE = '3',
}
export enum OPERATION_TYPE_ENUM {
  /**
   * 撤销
   */
  WITHDRAW = '1',
  /**
   * 编辑
   */
  EDIT = '2',
  /**
   * 开始更新
   */
  UPDATE = '3',
  /**
   * 更新完成
   */
  FINISHED = '4',
  DEFAULT = ''
}
export const NOTICE_TYPE_LIST = [
  { value: NOTICE_TYPE_ENUM.READY, label: '待更新' },
  { value: NOTICE_TYPE_ENUM.WITHDRAW, label: '已撤销' },
  { value: NOTICE_TYPE_ENUM.UPDATING, label: '更新中' },
  { value: NOTICE_TYPE_ENUM.COMPLETE, label: '已完成' },
];

/** 需更新系统 */
export enum NOTICE_SYSTEM_ENUM {
  PIMS = 'PIMS',
  PLM = 'PLM',
  // SCM = 'SCM',
  SCM = 'CX_SUPPLY_CHAIN',
  TS = 'CX_TRANSACTION',
  EPAI = 'EPAI'
}

export const NOTICE_SYSTEM_LIST = [
  { value: NOTICE_SYSTEM_ENUM.PIMS, label: 'PIMS' },
  { value: NOTICE_SYSTEM_ENUM.PLM, label: 'PLM' },
  { value: NOTICE_SYSTEM_ENUM.SCM, label: 'SCM' },
  { value: NOTICE_SYSTEM_ENUM.TS, label: 'TS' },
  { value: NOTICE_SYSTEM_ENUM.EPAI, label: 'EPAI' },
];

/** 需通知系统 */
export enum ONLINE_SYSTEM_ENUM {
  PIMS = 'PIMS',
  PLM = 'PLM',
  // SCM = 'SCM',
  SCM = 'CX_SUPPLY_CHAIN',
  TS = 'CX_TRANSACTION',
  EPAI = 'EPAI'
}

export const ONLINE_SYSTEM_LIST = [
  { value: ONLINE_SYSTEM_ENUM.PIMS, label: 'PIMS' },
  { value: ONLINE_SYSTEM_ENUM.PLM, label: 'PLM' },
  { value: ONLINE_SYSTEM_ENUM.SCM, label: 'SCM' },
  { value: ONLINE_SYSTEM_ENUM.TS, label: 'TS' },
  { value: ONLINE_SYSTEM_ENUM.EPAI, label: 'EPAI' },
];

/**
 * 获取字典返回
 */
export interface IDictValuesItem {
  channel: number | string; // 渠道。 1云版房
  creatorId: number | string; // 创建人id
  creatorName: string; // 创建人名称
  valueParentCode: string; // 父节点 code
  valueCode: string; // 字典值编号
  remark: string; // 备注
  sort: number | string; // 排序
  reviserName: string; // 更新人名称
  dictValueId: number | string; // 字典值id
  isDeleted: number | string; // 逻辑删除 0 否 1是
  dictCode: string; // 字典编码。关联dict_info表
  reviserId: number | string; // 更新人id
  isEnabled: number | string; // 是否启用 0 否 1是
  createdTime: string; // 创建时间
  value: string; // 字典值
  revisedTime: string; // 更新时间
  isEnable: number | string; // 是否启用 0 否 1是
  [k: string]: any;
}

/**
 * 字典编码列表
 */
export const DICT_CODE_TYPE_LIST = {
  DICT_CODE: ['ops_cms_systemCode'],
};
